import { API_BASE_URL } from "@/lib/api/config";

const MEDIA_BACKEND_ORIGIN = new URL(API_BASE_URL).origin;

export const getMediaUrl = (pathOrKey: string | null | undefined): string | null => {
  if (!pathOrKey) return null;
  if (pathOrKey.startsWith("blob:") || pathOrKey.startsWith("data:")) return pathOrKey;

  if (/^https?:\/\//i.test(pathOrKey)) {
    try {
      const url = new URL(pathOrKey);
      // Disa endpoints kthejnë storage/storage ose static/uploads për të
      // njëjtin objekt; publikojmë vetëm canonical /storage/{key}.
      url.pathname = url.pathname
        .replace(/^\/static\/uploads(?=\/|$)/, "/storage")
        .replace(/^\/(?:storage\/)+(?=storage\/)/, "/storage/")
        .replace(/^\/storage\/storage\//, "/storage/");
      return url.toString();
    } catch {
      return pathOrKey;
    }
  }

  if (pathOrKey.startsWith("/")) {
    pathOrKey = pathOrKey.replace(/^\/+/, "");
  }

  if (pathOrKey.startsWith("storage/storage/")) {
    return `${MEDIA_BACKEND_ORIGIN}/storage/${pathOrKey.slice("storage/storage/".length)}`;
  }

  if (pathOrKey.startsWith("storage/")) {
    return `${MEDIA_BACKEND_ORIGIN}/${pathOrKey}`;
  }

  if (pathOrKey.startsWith("static/uploads/")) {
    return `${MEDIA_BACKEND_ORIGIN}/storage/${pathOrKey.slice("static/uploads/".length)}`;
  }

  if (pathOrKey.startsWith("uploads/")) {
    return `${MEDIA_BACKEND_ORIGIN}/storage/${pathOrKey.slice("uploads/".length)}`;
  }

  const cleanPath = pathOrKey.replace(/^\/+/, "");

  if (cleanPath.startsWith("static/uploads.storage/")) {
    return `${MEDIA_BACKEND_ORIGIN}/storage/${cleanPath.slice("static/uploads.storage/".length)}`;
  }

  if (cleanPath.startsWith("uploads.storage/")) {
    return `${MEDIA_BACKEND_ORIGIN}/storage/${cleanPath.slice("uploads.storage/".length)}`;
  }

  if (cleanPath.startsWith("static/")) {
    return `${MEDIA_BACKEND_ORIGIN}/${cleanPath}`;
  }

  if (cleanPath.startsWith("uploads/")) {
    return `${MEDIA_BACKEND_ORIGIN}/static/${cleanPath}`;
  }

  return `${MEDIA_BACKEND_ORIGIN}/storage/${cleanPath}`;
};

export const resolveMediaUrl = getMediaUrl;
export const formatImageUrl = getMediaUrl;
